

















































import Vue from 'vue';
import SmallListLoader from '@/components/UI/Loader/SmallListLoader.vue';
import { FETCH_DUNNING_CAMPAIGN_BLUEPRINT } from '@/store/action-types';
import { IEmailBlueprint, IState } from '@/store/types';

export default Vue.extend({
  name: 'DunningCampaignGlance',
  components: {
    SmallListLoader,
  },
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    const state = this.$store.state as IState;
    const activeCampaignId = state.org?.dunning?.activeCampaign;
    await this.$store.dispatch(FETCH_DUNNING_CAMPAIGN_BLUEPRINT, activeCampaignId);
    this.loading = false;
  },
  computed: {
    activeCampaignId(): string | undefined {
      const state = this.$store.state as IState;
      return state.org?.dunning?.activeCampaign;
    },
    emails(): IEmailBlueprint[] {
      const state = this.$store.state as IState;
      if (this.activeCampaignId) {
        const activeCampaign = state.campaignBlueprints[this.activeCampaignId];
        if (activeCampaign) {
          return [...activeCampaign.emails].sort((a, b) => a.sendOnDay - b.sendOnDay);
        }
      }
      return [];
    },
  },
});
